import { InternalTransferListPage } from '@/features/internal-transfer/pages/InternalTransferListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/internal-transfer/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["internal_transfer.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: InternalTransferListPage,
})
